/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { MenuItem } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as actiontype from './store/actionTypes';
import {
  getPlanTypes,
  planType,
  errorMsgs,
  getRebateProgram,
  rebateProgram,
  getRebatePgmDetail,
  updateFirstload,
} from './store/actions';
import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  SEARCH_ROUTE,
  MAINTAIN_ROUTE,
  CREATE_NEW,
} from '../RebatePgmConstants';
import { getCheckPay, getDefaultAuditValues } from '../store/actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { getOverrideSystemData } from '../MaintainRebate/store/actions';

const SearchRebate = (props) => {
  const dispatch = useDispatch();
  const [radioList, setRadioList] = React.useState([]);
  const [load, setLoad] = React.useState(false);

  const plan_type = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.plan_type
  );
  const plan_list = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.plan_list
  );
  // const rebate_pgm_list = useSelector(
  //   (state) => state?.sharedState?.SearchRebateReducer?.rebate_pgm_list
  // );
  const rebate_pgm = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.rebate_pgm
  );
  const errors = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.error_arr
  );
  const pgm_view = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );
  const def_sys_aud = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.def_sys_aud
  );
  const unit_type = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.unit_type
  );
  const first_load = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.first_load
  );
  const sys_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.sys_override
  );
  const rebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const planTypeCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    if (!plan_list || !plan_list?.length) dispatch(getPlanTypes());
    dispatch(getDefaultAuditValues());
    if (!unit_type || !unit_type?.length) dispatch(getCheckPay('UNIT_TYPE_CD'));
    dispatch(getOverrideSystemData({}));
  }, []);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    if (plan_list) {
      const planList = plan_list?.PLAN_TYPE_CD?.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      if (planList)
        setRadioList([
          ...planList?.filter((obj) => obj.name == 'Medicaid'),
          ...planList?.filter((obj) => obj.name !== 'Medicaid'),
        ]);
      if (!first_load) {
        dispatch(updateFirstload());
        if (rebateProgramCd) dispatch(rebateProgram(rebateProgramCd));
        if (planTypeCd) dispatch(planType(planTypeCd));
        else if (!plan_type) dispatch(planType('FD'));
      }
    }
  }, [plan_list]);

  const [rebate_pgm_list, setRebatelist] = React.useState();
  const getDropdownData = async () => {
    const list = await dispatch(getRebateProgram(plan_type));
    setRebatelist(list);
  };

  React.useEffect(() => {
    if (plan_type) getDropdownData();
  }, [plan_type]);

  React.useEffect(() => {
    if (pgm_view && pgm_view.status === '001') {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      if (!updateTabs.some((ob) => ob.navTo === MAINTAIN_ROUTE)) {
        updateTabs.push({
          navTo: MAINTAIN_ROUTE,
          value: 'Maintain Rebate Program',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      }
      localStorage.setItem('viewpgmdetails', 'true');
      props.history.push({ pathname: MAINTAIN_ROUTE });
      dispatch({ type: actiontype.PGM_DETAIL, payload: {} });
    }
  }, [pgm_view]);

  React.useEffect(() => {
    if (errors && errors.length) {
      tabHighLigther(SEARCH_ROUTE, true);
    } else {
      tabHighLigther(SEARCH_ROUTE, false);
    }
  }, [errors]);

  const goToView = () => {
    if (rebate_pgm === '-1') {
      dispatch(errorMsgs([REBATE_SELECT]));
    } else {
      setLoad(true);
      dispatch(
        getRebatePgmDetail({
          planType: plan_type,
          rebateProg: rebate_pgm,
        })
      );
    }
  };

  const goToCreate = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (!updateTabs.some((ob) => ob.navTo === CREATE_NEW)) {
      updateTabs.push({
        navTo: CREATE_NEW,
        value: 'Rebate Program Create New',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
    props.history.push({ pathname: CREATE_NEW });
    localStorage.setItem('createpgmdetails', 'true');
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        dispatch(errorMsgs([REBATE_SELECT]));
        dispatch(rebateProgram(value));
      } else {
        dispatch(errorMsgs([]));
        dispatch(rebateProgram(value));
      }
    }
  };
  return (
    <div className="tabs-container" data-testid="searchRebate">
      <Spinner load={load} />
      <CustomSeparator parent1="Maintain" parent2="Rebate Program" />
      <DisplaySuccessMessages successMessages={[]} />
      <ErrorMessages errorMessages={errors || []} />
      <div className="row">
        <div className="col-sm-12  col-md-5 col-lg-5 frr-two-col-radio">
          <RadioGroupComponent
            labelName="Plan Type"
            data-testid="planType"
            optionList={radioList || []}
            defaultValue={plan_type}
            reqColor
            filterAction={(e) => {
              dispatch(planType(e));
              dispatch(rebateProgram('-1'));
            }}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <div className="mui-custom-form with-select">
            <TextField
              data-testid="rebate_program-ia"
              id="rebate_program"
              label="Rebate Program"
              fullWidth
              select
              required
              placeholder=""
              inputProps={{ maxLength: 11, id: 'rebate_program' }}
              onBlur={(e) =>
                handleOnblurEvent('rebateProgramCd', e.target.value)
              }
              InputLabelProps={{
                shrink: true,
              }}
              value={rebate_pgm}
              onChange={(e) => {
                dispatch(rebateProgram(e?.target?.value));
                dispatch(errorMsgs([]));
              }}
              className={
                errors?.length > 0
                  ? _.map(errors, (l) =>
                      l?.includes('Rebate Program is') ? 'mandate-fields' : null
                    )
                  : null
              }
              helperText={
                errors?.length > 0
                  ? _.map(errors, (l) =>
                      l?.includes('Rebate Program is') ? l : null
                    )
                  : null
              }
              error={
                errors?.length > 0
                  ? _.map(errors, (l) =>
                      l?.includes('Rebate Program is') ? l : null
                    )
                  : null
              }
            >
              <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />

              {rebate_pgm_list?.length > 0
                ? rebate_pgm_list.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </div>
        </div>
        <div className="col-sm-12 col-md-3 col-lg-3 pt-2">
          <Button
            id="viewpgm"
            data-testid="viewpgm"
            className="btn btn-success btn-search mb-1 btn btn-primary"
            onClick={goToView}
          >
            <SVGComponent iconName="Icon-view" /> View Program
          </Button>
          <br />
          <Button
            id="createpgm"
            data-testid="createpgm"
            className="btn btn-success btn-search mt-4"
            onClick={goToCreate}
            disabled={!isEnablebyRole}
          >
            <SVGComponent iconName="Create-new-icon" /> Create New Program
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchRebate;
